import React from 'react'
import { Logo } from '@pet-notify/ui'

import style from './style.module.css'

function AppHeader({ children }: { children?: React.ReactNode }) {
  return (
    <header className={style.wrapper}>
      <div className={style.inner}>
        <Logo />
        {children && <div className={style.content}>{children}</div>}
      </div>
    </header>
  )
}

export default AppHeader
